import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useMeetingHubContext } from '../MeetingHubContext';
import { useHubEvent } from 'hooks/useHubEvent';
import GridContainer from 'components/shared/GridContainer';
import GridItem from 'components/shared/GridItem';
import AttendanceSection from '../AttendanceSection';
import ConferenceInfoSection from '../ConferenceInfoSection';
import MeetingSessionPanel from '../MeetingSessionPanel';
import ActivityLogViewCard from '../ActivityLogModal/ActivityLogViewCard';
import MeetingHubEvents from 'store/enums/MeetingHubActions';
import { ActivityType } from 'store/enums/BallotReviewTypes';
import { activityLogQueryParameter } from 'util/meeting';

const MeetingMemberView: React.FunctionComponent = () => {
  const [searchParams] = useSearchParams();
  const showActivityLog = searchParams.get(activityLogQueryParameter);

  const { activityLogs, connection, refetchAttendees, refetchMeetingSession, refetchActivityLogs } =
    useMeetingHubContext();
  const displayLogs = useMemo(
    () => (activityLogs ?? []).filter((log) => log.type !== ActivityType.Connection),
    [activityLogs]
  );

  useHubEvent(connection, MeetingHubEvents.SessionUpdated, refetchMeetingSession);
  useHubEvent(connection, MeetingHubEvents.AttendeeUpdated, refetchAttendees);
  useHubEvent(connection, MeetingHubEvents.AttendeeRemoved, refetchAttendees);
  useHubEvent(connection, MeetingHubEvents.ActivityLogAdded, refetchActivityLogs);
  useHubEvent(connection, MeetingHubEvents.ActivityLogRemoved, refetchActivityLogs);

  return showActivityLog === 'true' ? (
    <GridContainer>
      {displayLogs.map((log) => (
        <GridItem key={log.id}>
          <ActivityLogViewCard activityLog={log} />
        </GridItem>
      ))}
    </GridContainer>
  ) : (
    <GridContainer>
      <GridItem>
        <ConferenceInfoSection />
      </GridItem>
      <GridItem>
        <AttendanceSection />
      </GridItem>
      <GridItem>
        <MeetingSessionPanel />
      </GridItem>
    </GridContainer>
  );
};

export default MeetingMemberView;
